"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

var _index2 = require("../../../../utils/index");

var _cta_helpers = require("../cta_helpers.js");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _link_styles = _interopRequireDefault(require("./link_styles"));

var _link_definition = _interopRequireDefault(require("./link_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// helpers
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : LINK ~~~~~~~~~~ ========== */


var Link = (0, _reactJss.default)(_link_styles.default)(function (props) {
  var handleTarget = function handleTarget() {
    switch (props.target) {
      case 'external':
        return '_blank';

      case 'internal':
      default:
        return '_self';
    }
  };

  var isActive = function isActive() {
    return props.isActive === true || props.currentPage.includes(props.name) || props.currentPage.includes(props.action) ? true : false;
  };

  var displayActiveClass = function displayActiveClass() {
    switch (props.type) {
      case 'internal':
        return props.name === 'logout' || props.behavior === 'back' ? "isActive-false" : "isActive-".concat(isActive());

      case 'scroll':
        return props.activeSection === props.name ? "isActive-true" : "isActive-false";
      // section id and link name must match

      default:
        return props.isActive !== undefined ? "isActive-".concat(!!props.isActive) : "";
    }
  };

  var handleHREF = function handleHREF() {
    switch (props.type) {
      case 'external':
      case 'email':
        return props.action;

      case 'internal':
        return props.action.substring(props.action.indexOf('/')).replace('/', '');
      // removing division and slash so the preview of this from the browser looks correct

      default:
        return "#action-".concat(props.name);
    }
  };

  return _react.default.createElement("span", {
    className: "cta link ".concat((0, _index2.generateClasses)(props, ['iconRight', 'iconOnly']), " disabled-").concat(props.disabled, " icon-").concat(!!props.icon, " underline-").concat(props.underline ? true : props.underline, " processing-").concat(props.processing, " allowmulticlick-").concat(!!props.allowMultiClick, " ").concat(displayActiveClass(), " ").concat(props.classes.link),
    onClick: function onClick(e) {
      return (0, _cta_helpers.handleClick)(props, e);
    }
  }, _react.default.createElement("a", {
    href: handleHREF(),
    target: handleTarget(),
    title: props.title
  }, props.icon || props.text ? _react.default.createElement("span", {
    className: "inner"
  }, (0, _cta_helpers.handleIcon)(props), _react.default.createElement("span", {
    className: "text"
  }, (0, _cta_helpers.handleText)(props.processing, props.operation, props.text)), props.badge ? _react.default.createElement(_index.Badge, {
    type: props.badge
  }) : null) : props.children), props.divider ? _react.default.createElement("span", {
    className: "divider"
  }, "|") : null);
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(Link, _link_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Link;
exports.default = _default;